import {Component, Input, ChangeDetectorRef, OnInit, Optional} from '@angular/core';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {QuestionnaireEditorService} from '../../../services/questionnaire-editor.service';
import {QuestionnaireStateService} from '../../../services/questionnaire-state.service';
import {TRANSLATION_EDITOR_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';
import {QuestionnaireVariablesService} from '../../../services/questionnaire-variables.service';


// hack to inject decorator declarations. must occur before class declaration!
export interface QuestionTypeDocumentScanComponent extends Translatable {}

@Component({
  selector: 'app-qa-question-document-scan',
  templateUrl: './question-type-document-scan.component.html',
  styleUrls: ['./question-type-document-scan.component.css']
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class QuestionTypeDocumentScanComponent implements OnInit {
  @Input() question: Questionnaire.Container;

  /**
   * Locale for questionnaire. Hardcoded to "de_DE" for now.
   * We need to change this, when we implement multi language support
   * @type {string}
   */
  public locale = 'de_DE';

  /**
   * Injects dependencies  
   */
  public constructor(
    private state: QuestionnaireStateService,
    private editor: QuestionnaireEditorService,
    private ref: ChangeDetectorRef,
    private variables: QuestionnaireVariablesService,
    @Optional() private translationService: TranslationService
  ) {
  }

  /**
   * Component initialization
   */
  public ngOnInit(): void {
    this.createUploadVariable();
  }

  /**
   * Creates an automatic upload variable for document scanning
   */
  private createUploadVariable(): void {
    if (!this.question.pathHash) {
      return;
    }

    const uploadVariables = this.variables.getVariablesForScope('upload');
    const pathHashToVarName = this.variables.flipVariables(uploadVariables);
    
    if (pathHashToVarName[this.question.pathHash]) {
      return;
    }

    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let randomStr = '';
    for (let i = 0; i < 8; i++) {
      randomStr += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    const variableName = `document_scan_${randomStr}`;
    this.variables.addVariableMapping('upload', variableName, this.question.pathHash, {keepMe: true});
  }

  /**
   * Updates the minimum pages setting
   */
  public onMinPagesChange(value: number) {
    if (!this.question.options) {
      this.question.options = {};
    }
    if (!this.question.options.scanOptions) {
      this.question.options.scanOptions = {};
    }
    this.question.options.scanOptions.minPages = Math.max(1, value);
    
    // Ensure maxPages is at least minPages
    if (this.question.options.scanOptions.maxPages && 
        this.question.options.scanOptions.maxPages < this.question.options.scanOptions.minPages) {
      this.question.options.scanOptions.maxPages = this.question.options.scanOptions.minPages;
    }
  }

  /**
   * Updates the maximum pages setting
   */
  public onMaxPagesChange(value: number) {
    if (!this.question.options) {
      this.question.options = {};
    }
    if (!this.question.options.scanOptions) {
      this.question.options.scanOptions = {};
    }
    this.question.options.scanOptions.maxPages = Math.max(1, value);
    
    // ensure minPages is at most maxPages
    if (this.question.options.scanOptions.minPages && 
        this.question.options.scanOptions.minPages > this.question.options.scanOptions.maxPages) {
      this.question.options.scanOptions.minPages = this.question.options.scanOptions.maxPages;
    }
  }

  /**
   * Returns the current minimum pages value
   */
  public get minPages(): number {
    return this.question.options?.scanOptions?.minPages || 1;
  }

  /**
   * Returns the current maximum pages value
   */
  public get maxPages(): number {
    return this.question.options?.scanOptions?.maxPages || 100;
  }
}
